import React from "react";
import { FallbackProps } from "react-error-boundary";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

export const ErrorFallback = ({ error, resetErrorBoundary }: FallbackProps) => {
  return (
    <main className="min-h-screen w-full flex items-center justify-center bg-background px-6 py-16">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="max-w-lg w-full bg-card border border-border rounded-xl p-10 shadow-[0_8px_30px_rgba(0,0,0,0.08)] text-center"
      >
        <h1 className="text-4xl font-light italic text-primary mb-4">
          Something went wrong
        </h1>

        <p className="text-foreground/70 mb-6 leading-relaxed">
          An unexpected error occurred. You can try reloading this section or
          return to the home page.
        </p>

        {/* Error Details (collapsible) */}
        <details className="text-left text-sm text-red-500/70 mb-6 bg-red-50/50 p-3 rounded-md border border-red-200">
          <summary className="cursor-pointer font-semibold text-red-600">
            Error Details
          </summary>
          <pre className="mt-2 whitespace-pre-wrap text-red-500 text-xs">
            {error?.message}
          </pre>
        </details>

        {/* Buttons */}
        <div className="flex flex-col sm:flex-row justify-center gap-4">
          <button
            onClick={resetErrorBoundary}
            className="px-8 py-3 bg-primary text-primary-foreground rounded-lg font-semibold shadow hover:shadow-md transition-all"
          >
            Try Again
          </button>

          <Link
            to="/"
            className="px-8 py-3 border border-primary text-primary rounded-lg font-semibold shadow hover:bg-primary/5 transition-all"
          >
            Go Home
          </Link>
        </div>
      </motion.div>
    </main>
  );
};
